module.exports = __webpack_public_path__ + "media/notification.b5e7acad.mp3";